<div class="tenant-role">
  <a href="javascript:void(0)" class="back-link" (click)="goBack()">
    <i class="bi bi-chevron-left"></i> Back to Overview
  </a>

  <div class="page-heading-row">
    <div class="page-heading-text">
      <h2 class="page-title">Roles</h2>
      <p class="page-subtitle">Manage roles and permissions per service</p>
    </div>

    <div class="service-tabs">
      @for (s of services; track s.key) {
        <button
          type="button"
          class="service-tab"
          [class.active]="selectedService === s.key"
          (click)="selectService(s.key)"
        >
          <i class="bi" [class]="s.icon"></i>
          {{ s.label }}
        </button>
      }
    </div>
  </div>

  @switch (selectedService) {
    @case ('datastream') {
      <app-tenant-role-datastream />
    }
    @case ('immunity') {
      <app-tenant-role-immunity />
    }
    @case ('mdm') {
      <app-tenant-role-mdm />
    }
  }
</div>
